module.exports = __webpack_public_path__ + "cross-black-bg.png?b22d64baea4798383903817e5d0b8e9f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cross-black-bg.png
// module id = 260
// module chunks = 0 1 3